/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Reports {
    angular.module("meevo.plugins.reports", []);
}